import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = '/admin/sales/forecast-tools'

export default {
  getForecastList(filterQuery){
    return Repository.get(`${resource}?${filterQuery}`)
  },
  createForecast(payload){
    return Repository.post(`${resource}`,payload)
  },
  getForecast(id){
    return Repository.get(`${resource}/${id}`)
  },
  updateForecast(id,payload){
    return Repository.put(`${resource}/${id}`,payload)
  },
  deleteForecast(id){
    return Repository.delete(`${resource}/${id}`)
  },
  getFilteredForeCastFormulation(customer_id) {
    return Repository.get(`/admin/sales/forecast-tool/filtered-formulation?customer_id=${customer_id}`)
  },
  downloadExcelDocument(customer_id, customer_lead_id, formulation_id, from, to){
    return Repository.get(`/admin/sales/forecast-tool/export?customer_id=${customer_id}&formulation_id=${formulation_id}&from=${from}&to=${to}&customer_lead_id=${customer_lead_id}`,{
      responseType:'blob'
    })
  }
}
